import React, { useRef, useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Context } from './LanguageWrapper';
import { ReactComponent as Menu } from '../assets/svgs/burger-menu.svg';
import { ReactComponent as Close } from '../assets/svgs/close-menu.svg';
import { ReactComponent as Settings } from '../assets/svgs/settings.svg';
import { ReactComponent as Back } from '../assets/svgs/back.svg';
import { LANGUAGES, MENU } from '../config';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '../App';
import { usePerservedState } from '../utils/versionDataUtil';
import '../pages/pages.css';

function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const { theme, toggleTheme } = useTheme();
    const [settingsOpen, setSettingsOpen] = useState(false);
    const menuRef = useRef(null);
    const { locale, selectLanguage } = useContext(Context);
    const [saveAwakening, setSaveAwakening] = usePerservedState('saveAwakening', false)
    const [defaultAwakening, setDefaultAwakening] = usePerservedState('defaultAwakening', true)

    const toggleMenu = () => {
        setIsOpen(prevIsOpen => !prevIsOpen);
    };

    const toggleSettings = () => {
        setSettingsOpen(prevSettingsOpen => !prevSettingsOpen);
    };

    const handleAwakeningChange = (event) => {
        setSaveAwakening(event.target.value === 'true');
    };

    const handleDefaultChange = (event) => {
        setDefaultAwakening(event.target.value === 'true');
    };


    const navLinks = [
        {
            path: '/',
            label: <FormattedMessage
                id="header.home"
                defaultMessage="Home"
            />,
            icon: MENU.icon
        },
        {
            path: '/characters',
            label: <FormattedMessage
                id="main.characters"
                defaultMessage="Characters"
            />,
            icon: MENU.characters
        },
        {
            path: '/skills',
            label: <FormattedMessage
                id="main.skills"
                defaultMessage="Skills"
            />,
            icon: MENU.skills
        },
        {
            path: '/buffs',
            label: <FormattedMessage
                id="header.buffs"
                defaultMessage="Buffs & Status Ailements"
            />,
            icon: MENU.buffs
        }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                if (event.target.type !== 'checkbox') {
                    setIsOpen(false);
                    setSettingsOpen(false);
                }
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <header className="Header">
            {!isOpen && (
                <Menu
                    className='burger-icon'
                    onClick={toggleMenu}
                />
            )}
            {isOpen && (
                <Close
                    className="burger-icon"
                />
            )}
            <div className="mobile-nav" ref={menuRef}>
                <nav className={`overlay-menu ${isOpen ? 'open' : ''}`} >
                    <ul className="mobile-nav-ul">
                        {!settingsOpen ? (
                            <>
                                {navLinks.map((link, index) => (
                                    <li className="mobile-nav-li" key={link.path}>
                                        <img className="menu-icon" alt={link.label} src={link.icon} />
                                        <NavLink
                                            to={link.path}
                                            onClick={toggleMenu}
                                            className={({ isActive }) => (isActive ? 'active-link' : '')}
                                        >
                                            {link.label}

                                        </NavLink>
                                    </li>
                                ))}
                            </>
                        ) : (
                            <>
                                <li className="mobile-nav-li">
                                    <FormattedMessage
                                        id="header.theme"
                                        defaultMessage="Theme"
                                    />
                                    <select
                                        value={theme}
                                        onChange={toggleTheme}
                                        className="sort-select"
                                    >
                                        <option value={'dark'}>
                                            <FormattedMessage
                                                id="header.dark"
                                                defaultMessage="Dark"
                                            />
                                        </option>
                                        <option value={'light'}>
                                            <FormattedMessage
                                                id="header.light"
                                                defaultMessage="Light"
                                            />
                                        </option>
                                    </select>
                                </li>
                                <li className="mobile-nav-li">
                                    <FormattedMessage
                                        id="header.language"
                                        defaultMessage="Language"
                                    />
                                    <select
                                        value={locale}
                                        onChange={selectLanguage}
                                        className="sort-select"
                                    >
                                        {LANGUAGES.map(lang => (
                                            <option key={lang.code} value={lang.code}>
                                                {lang.label}
                                            </option>
                                        ))}
                                    </select>
                                </li>
                                <li className="mobile-nav-li">
                                    <FormattedMessage
                                        id="header.default"
                                        defaultMessage="Save Awakening"
                                    />
                                    <select
                                        value={defaultAwakening}
                                        onChange={handleDefaultChange}
                                        className="sort-select"
                                    >
                                        <option value={true}>
                                            <FormattedMessage
                                                id="header.a0"
                                                defaultMessage="A5"
                                            />
                                        </option>
                                        <option value={false}>
                                            <FormattedMessage
                                                id="header.a5"
                                                defaultMessage="A0"
                                            />
                                        </option>
                                    </select>
                                </li>
                                <li className="mobile-nav-li">
                                    <FormattedMessage
                                        id="header.save"
                                        defaultMessage="Save Awakening"
                                    />
                                    <select
                                        value={saveAwakening}
                                        onChange={handleAwakeningChange}
                                        className="sort-select"
                                    >
                                        <option value={false}>
                                            <FormattedMessage
                                                id="header.no"
                                                defaultMessage="No"
                                            />
                                        </option>
                                        <option value={true}>
                                            <FormattedMessage
                                                id="header.yes"
                                                defaultMessage="Yes"
                                            />
                                        </option>

                                    </select>
                                </li>
                            </>
                        )}
                    </ul>
                    <ul className="mobile-nav-ul">
                        <li className="mobile-nav-li">
                            {settingsOpen ? (
                                <Back
                                    onClick={toggleSettings}
                                    className="settings-icon" />
                            ) : (
                                <Settings
                                    onClick={toggleSettings}
                                    className="settings-icon" />
                            )}

                        </li>
                    </ul>
                </nav>
            </div>
        </header >
    );
}

export default Header;